import {writable} from "svelte/store";
import type {DeviceFilter, DeviceFilterState} from "./devices";

export type ModalStore = {
    key: 'device-group-dialog'
    data?: { filter: DeviceFilter, key: string }
    callback?: (data?: DeviceFilter | null) => void
} | {
    key: 'device-filter-dialog'
    data?: { filter?: DeviceFilterState }
    callback?: (data?: DeviceFilterState) => void
} | {
    key: 'search-dialog'
    data?: undefined
    callback?: undefined
} | {
    key: 'confirmation-dialog'
    data?: {
        title: string
        message: string
        confirmLabel?: string
        cancelLabel?: string
        variant?: 'error' | 'warning' | 'info'
    }
    callback?: (confirmed: boolean) => void
} | {
    key: 'device-log-fullscreen'
    data?: { deviceId: string, deviceName: string }
    callback?: () => void
} | {
    key: 'location-picker-modal'
    data?: undefined
    callback?: (data: {lat: number, lng: number, address: string} | null) => void
} | {
    key: 'device-action-dialog'
    data: { action: string, deviceId: string, initialValue?: string }
    callback?: (result: { action: string, value: string } | null) => void
} | {
    key: 'chrome-action-dialog'
    data: { action: string, deviceId: string }
    callback?: (result: { action: string, value: string } | null) => void
}

export const modalStore = writable<ModalStore | undefined>()

export const closeModals = (data?: any): void => {
    modalStore.update(state => {
        state?.callback?.(data)
        return undefined
    })
}

export interface TooltipStore {
    component: any
    props: any
    position: { x: number; y: number }
}

export const tooltipStore = writable<TooltipStore | undefined>()

export const closeTooltip = (): void => {
    tooltipStore.set(undefined)
}